import { useState, useEffect } from "react";
import axios from "axios";
import api from "../../../Api";

// Define an interface for log items
interface LogItem {
  id: string;
  day: string; // Example: "24 November 2024"
  time: string; // Example: "12:21:08 PM"
  timeZone: string;
  message: string;
}

export default function Systemlogs() {
  const [logData, setLogData] = useState<LogItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchLogs = async () => {
    try {
      const response = await axios.get<{ logs: LogItem[] }>(api.logs, {
        headers: {
          api_key: api.key,
          authentication: api.authantication,
        },
      });

      // Sort logs from latest to oldest
      const sortedLogs = response.data.logs.sort((a, b) => {
        const dateA = new Date(`${a.day} ${a.time}`);
        const dateB = new Date(`${b.day} ${b.time}`);
        return dateB.getTime() - dateA.getTime();
      });

      setLogData(sortedLogs);
    } catch (error) {
      console.error("Error fetching logs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch logs on component mount
  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className="space-y-4">
      {isLoading
        ? // Render skeleton loaders while loading
          Array.from({ length: 6 }).map((_, index) => (
            <div
              key={index}
              className="bg-gray-200 animate-pulse border rounded p-4 flex items-center"
            >
              <div className="w-[80%]">
                <div className="h-4 bg-gray-300 rounded"></div>
              </div>
              <div className="w-[20%] flex justify-end">
                <div className="h-4 bg-gray-300 rounded w-24"></div>
              </div>
            </div>
          ))
        :
          logData.map((log) => (
            <div
              key={log.id}
              className="bg-white border rounded p-4 flex items-center"
            >
              <div className="w-[80%]">
                <p>{log.message}</p>
              </div>
              <div className="w-[20%] flex justify-end">
                <p>
                  {log.day} <span className="text-red-500">{log.time}</span>
                </p>
              </div>
            </div>
          ))}
    </div>
  );
}
